(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enova-favoritos-enkasa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('enova-favoritos')) return;

    class EnovaFavoritos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fav-track]');
        this.prevBtn = this.querySelector('[data-fav-prev]');
        this.nextBtn = this.querySelector('[data-fav-next]');
        this.dotsWrap = this.querySelector('[data-fav-dots]');
        this.controls = this.querySelector('[data-fav-controls]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.rebuild = this.rebuild.bind(this);

        this.prevBtn && this.prevBtn.addEventListener('click', () => this.scrollPage(-1));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.scrollPage(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.rebuild);

        this.rebuild();
        setTimeout(this.rebuild, 300); // re-cálculo cuando imágenes/layout asientan
      }

      pageW() { return this.track.clientWidth; }
      pages() { return Math.max(1, Math.ceil(this.track.scrollWidth / this.pageW())); }
      current() { return Math.round(this.track.scrollLeft / this.pageW()); }

      scrollPage(dir) {
        this.track.scrollBy({ left: dir * this.pageW(), behavior: 'smooth' });
      }
      scrollToPage(i) {
        this.track.scrollTo({ left: i * this.pageW(), behavior: 'smooth' });
      }

      rebuild() {
        var overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        if (this.controls) this.controls.style.display = overflow ? 'flex' : 'none';

        if (this.dotsWrap) {
          var n = overflow ? this.pages() : 0;
          this.dotsWrap.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'fav__dot';
            b.setAttribute('aria-label', 'Ir a la página ' + (i + 1));
            (function (idx, self) {
              b.addEventListener('click', function () { self.scrollToPage(idx); });
            })(i, this);
            this.dotsWrap.appendChild(b);
          }
        }
        this.update();
      }

      update() {
        var t = this.track;
        var atStart = t.scrollLeft <= 2;
        var atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
        if (this.dotsWrap) {
          var cur = this.current();
          var dots = this.dotsWrap.children;
          for (var i = 0; i < dots.length; i++) {
            dots[i].setAttribute('aria-current', i === cur ? 'true' : 'false');
          }
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.rebuild);
      }
    }

    window.customElements.define('enova-favoritos', EnovaFavoritos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enova-hot-sales"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('enova-hot-sales')) return;

    class EnovaHotSales extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ehs-track]');
        this.prevBtn = this.querySelector('[data-ehs-prev]');
        this.nextBtn = this.querySelector('[data-ehs-next]');
        if (!this.track) return;

        this.onPrev = () => this.track.scrollBy({ left: -this.page(), behavior: 'smooth' });
        this.onNext = () => this.track.scrollBy({ left: this.page(), behavior: 'smooth' });
        this.update = this.update.bind(this);

        this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
        this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);

        this.update();
        // Re-check once images/layout settle
        setTimeout(this.update, 300);
      }

      page() {
        return Math.round(this.track.clientWidth * 0.9);
      }

      update() {
        var t = this.track;
        var overflow = t.scrollWidth > t.clientWidth + 2;
        var atStart = t.scrollLeft <= 2;
        var atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = !overflow || atStart;
        if (this.nextBtn) this.nextBtn.disabled = !overflow || atEnd;
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
    }

    window.customElements.define('enova-hot-sales', EnovaHotSales);
  })();

  } catch(e) { console.error(e); }
})();
})();
